export default {
    nome: 'UPBUSCA',
    legenda: 'Prospecção de novos clientes'
}